<template>
  <VBlock class="not-progress-orders" :direction="Direction.column" :sort="Sort.left_center">
    <VBlock v-for="(order, index) in contentPage.content" :key="index">
      <VBlock class="order-card" :direction="Direction.column">
        <!-- TODO 아이콘 -->
        <VBlock class="inner-wrapper" :direction="Direction.column" :sort="Sort.left_center">
          <VBlock class="inner-contents" :sort="Sort.left_center">
            <VBlock class="contents-text" :direction="Direction.column" :sort="Sort.left_center">
              <VBlock v-if="order.isDisplayDeliveryTitle" :sort="Sort.left_center">
                <VImage class="icon-image" :src="resources.icon" :width="42" :height="42" />
                <VSpan
                  class="date-text"
                  :text="`${order.displayDeliveryTitle} ${order.shopName}에서`"
                  :size="14"
                  :color="TextColor.darkGray"
                />
                <VSpan v-if="order.isCancelled" text="취소완료" :color="TextColor.emergency" :size="14" />
                <VSpan v-else text="주문한" :color="TextColor.darkGray" :size="14" />
              </VBlock>
              <VP class="shop-name" :text="order.orderName" :size="20" :weight="TextWeight.bold" />
              <VBlock class="description" :sort="Sort.left_center">
                <VP
                  class="description-text"
                  :text="`${order.paymentAmount}원`"
                  :size="16"
                  :color="TextColor.darkGray"
                  :type="TextType.Number"
                />
              </VBlock>
              <VBlock v-if="order.reservation" class="reservation-wrapper">
                <VSpan class="reservation-text" text="예약" :size="10" />
              </VBlock>
            </VBlock>
          </VBlock>

          <VBlock class="order-history-button-wrapper">
            <!-- <VButton class="order-history-button" :onClick="() => { onBmartMove() }" :radius="4">
              <VBlock class="order-history-button-inner">
                <VBlock class="order-history-button-image-wrapper" :padding="[0, 4, 2, 0]">
                  <VImage :src="resources.deliveryReturnIcon" :width="25" :height="25" />
                </VBlock>
                <VSpan text="B마트 홈" :size="14" />
              </VBlock>
            </VButton>-->
            <VButton
              class="order-history-button"
              :onClick="
                () => {
                  onContent(order.orderId)
                }
              "
              :radius="4"
            >
              <VBlock class="order-history-button-inner">
                <VBlock class="order-history-button-image-wrapper" :padding="[0, 4, 2, 0]">
                  <VImage :src="resources.deliveryDetailIcon" :width="25" :height="25" />
                </VBlock>
                <VSpan text="주문상세" :size="14" />
              </VBlock>
            </VButton>
          </VBlock>
        </VBlock>
      </VBlock>
    </VBlock>
  </VBlock>
</template>

<script>
import VBlock, { Direction, Sort } from '../../molecules/VBlock/index'
import VSpan, { TextType, TextColor, TextWeight } from '../../atoms/VSpan/index'
import VP from '../../atoms/VP'
import VButton from '../../atoms/VButton'
import VA from '../../molecules/VA/index'
import VImage from '../../atoms/VImage'

import icon from '@/assets/images/bmart-nor-42@2x.png'

import deliveryReturnIcon from '@/assets/images/delivery-return.svg'
import deliveryDetailIcon from '@/assets/images/delivery-detail-normal.svg'

export default {
  name: 'NotInProgressOrders',
  components: { VA, VSpan, VBlock, VButton, VImage, VP },
  props: {
    contentPage: {
      type: Object, // src/v2-models/MyOrder/Page.js:1; class 노출 안되어있음...
      required: true
    },
    onContent: {
      type: Function,
      required: true
    }
    // onBmartMove: {
    //   type: Function,
    //   required: true
    // }
  },
  data() {
    return {
      Direction,
      Sort,
      TextType,
      TextColor,
      TextWeight,

      resources: {
        icon,
        deliveryReturnIcon,
        deliveryDetailIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.not-progress-orders {
  padding-bottom: 50px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 50px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 50px);

  .order-card {
    width: 100%;
    height: auto;
    border-bottom: 1px solid $light-gray-5;
    padding: 0 2px 0 2px;
    margin-top: 10px;

    box-sizing: border-box;
    background-color: $white;

    .inner-wrapper {
      height: auto;
      padding: 15px 15px 25px 15px;
      box-sizing: border-box;

      .inner-contents {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: left;
        margin-bottom: 15px;
        box-sizing: border-box;

        .contents-text {
          width: 100%;
          height: auto;
          padding-right: 10px;
          box-sizing: border-box;

          .icon-image {
            margin-right: 4px;
          }

          .date-text {
            letter-spacing: -0.36px;
            color: $dark-gray !important;
            margin-right: 4px;
          }

          .shop-name {
            margin-top: 8px;
            margin-bottom: 4px;
            white-space: pre-line;
            text-align: left;
            letter-spacing: -0.4px;
            line-height: 1.1;
            margin-bottom: 5px;
          }

          .description {
            width: 100%;
            height: auto;
            /* margin-bottom: 6px; */
            // overflow: hidden;
            // white-space: nowrap;
            // text-overflow: ellipsis;

            .description-text {
              width: 100%;
              height: auto;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: left !important;
            }
          }

          .reservation-wrapper {
            width: auto;
            height: auto;
            padding: 5px 7px 2px 7px;
            margin-top: 4px;
            border-radius: 2px;
            background-color: $light-gray-8;
            margin-bottom: 5px;

            .reservation-text {
              width: auto;
              height: auto;
            }
          }
        }
      }
    }

    .order-history-button-wrapper {
      width: 100%;
      height: auto;
      // padding: 0 10px 0 10px;
      box-sizing: border-box;
      /* margin-top: 4px; */

      .order-history-button {
        width: 100%;
        height: auto;
        padding: 13px 0 13px 0;
        box-sizing: border-box;
        /* border-collapse: collapse; */
        border: 1px solid $light-gray-4;

        .order-history-button-inner {
          .order-history-button-image-wrapper {
            width: auto;
          }
        }

        &:first-child {
          margin-right: 2.5px;
          /* border-top-left-radius: 4px !important;
        border-bottom-left-radius: 4px !important; */
        }

        &:last-child {
          margin-left: 2.5px;
          /* margin-left: -1px;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important; */
        }
      }
    }
  }
}
</style>
